var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermalPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9414 9.42463L19.4481 4.91797",
    stroke: "#323232",
    strokeWidth: 0.853846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1775 7.64844L17.6816 12.1551",
    stroke: "#323232",
    strokeWidth: 0.853846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3633 6.84766L20.2716 14.7452",
    stroke: "#323232",
    strokeWidth: 0.853846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41928 20.4193L7.83856 20L7 19.1614L6.58072 19.5807L7.41928 20.4193ZM3.33072 22.8307C3.09916 23.0623 3.09916 23.4377 3.33072 23.6693C3.56228 23.9008 3.93772 23.9008 4.16928 23.6693L3.33072 22.8307ZM6.58072 19.5807L3.33072 22.8307L4.16928 23.6693L7.41928 20.4193L6.58072 19.5807Z",
    fill: "#323232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3203 3.79297L23.2495 8.72214",
    stroke: "#323232",
    strokeWidth: 0.853846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7494 13.2243L11.6677 20.306C10.8216 21.1521 9.45008 21.1521 8.60399 20.306L6.86308 18.5673C6.01699 17.7212 6.01699 16.3497 6.86308 15.5036L13.9448 8.42188",
    stroke: "#323232",
    strokeWidth: 0.853846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermalPaste);
export default __webpack_public_path__ + "static/media/thermalPaste.02a9ed966a664d421466437c4d94046b.svg";
export { ForwardRef as ReactComponent };